import React from 'react';
import { 
  FileText, 
  ArrowLeft,
  Shield,
  AlertCircle
} from 'lucide-react';
import { useLocalization } from '../../contexts/LocalizationContext';
import { useTheme } from '../../contexts/ThemeContext';
import { useNavigate } from 'react-router-dom';
import AnnouncementBar from '../../components/AnnouncementBar';
import Footer from '../../components/Footer';

const TermsAndConditions: React.FC = () => {
  const { language, setLanguage, isRTL } = useLocalization();
  const { isDark, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const content = {
    ar: {
      title: "الشروط والأحكام",
      lastUpdated: "آخر تحديث: 23 أكتوبر 2026 (الإصدار 2.4.0)",
      sections: [
        {
          title: "1. قبول الشروط",
          content: "باستخدامك لمنصة مرافعة فإنك توافق على هذه الشروط. إن لم توافق فلا تستخدم الخدمة."
        },
        {
          title: "2. التعريفات",
          content: "المنصة: الموقع والتطبيقات والخدمات. المستخدم: من يستخدم المنصة. المحتوى: البيانات والملفات. مقدم الخدمة: أوبتيميز وير. بيانات العملاء: معلومات الموكلين والقضايا. Ad-Free: استحقاق يخفي إعلانات التطبيق أثناء سريانه."
        },
        {
          title: "3. وصف الخدمة",
          content: "إدارة ممارسة قانونية في مصر: موكلون وقضايا وأجندة وملفات وتعاون وفوترة، ودليل المحامي والمكتبة (مرجع عام وليس استشارة قانونية)، وبرنامج إحالة مع مكافآت Ad-Free، واستبيانات اختيارية، وتحليلات وفق سياسة الخصوصية، وإعلانات على الشرائح المجانية."
        },
        {
          title: "4. الأهلية والتسجيل",
          content: "قدّم بيانات صحيحة واحفظ سرية الحساب. يُفضَّل حساب واحد لكل شخص/كيان. المنصة للبالغين من المهنيين القانونيين."
        },
        {
          title: "5. سياسة الاستخدام المقبول",
          content: "استخدام قانوني فقط. يُحظر الاستخدام غير القانوني والبرمجيات الخبيثة والوصول غير المصرح والمضايقة والانتحال وحصاد البيانات دون موافقة وإساءة برنامج الإحالة بما في ذلك الحسابات الوهمية أو الإحالة الذاتية."
        },
        {
          title: "6. حماية البيانات والخصوصية",
          content: "المعالجة وفق سياسة الخصوصية (القانون 151 لسنة 2020)، بما في ذلك النقل عبر TLS وضوابط المعالجين وحقوقك في الوصول والتصحيح والحذف."
        },
        {
          title: "7. سرية العملاء",
          content: "بيانات العملاء مسؤوليتك المهنية. لا نستخدمها إلا لتقديم الخدمة ولا نشاركها مع شبكات الإعلانات لتخصيص الإعلانات. المنصة لا تستبدل واجباتك كمحامٍ."
        },
        {
          title: "8. الملكية الفكرية",
          content: "محتوى المنصة لأوبتيميز وير. محتواك ملكك مع ترخيص محدود لنا للاستضافة والمعالجة."
        },
        {
          title: "9. الدفع والاستحقاقات الترويجية",
          content: "الأسعار بالجنيه المصري شاملة ضريبة القيمة المضافة ما لم نُصرّح بخلاف ذلك. قد تُستخدم Kashier للبطاقات والمحافظ. لا نستخدم Google Play Billing لـ Ad-Free. لا تُرد عادةً الفترات الجزئية إلا إذا اقتضى القانون المصري. أشهر الإحالة ليست نقداً وغير قابلة للتحويل. قد نوقف الدفع في التطبيق أو ننقله للموقع دون المساس بمنحة مدفوعة."
        },
        {
          title: "9هـ. Ad-Free المدفوع (2.4.0 — مفعّل)",
          content: "السعر: 50 جنيهاً شاملة الضريبة لكل منحة. المدة: 30 يوماً من تحقق الدفع — جلسة Kashier لمرة واحدة وليست اشتراك Google Play ولا تجديداً صامتاً؛ كل فترة إضافية تتطلب دفعاً جديداً. يشمل إخفاء الإعلانات المؤهلة على التطبيق والموقع للحساب. لا يشمل إصدارات المكتبة ولا رصيد الذكاء الاصطناعي ولا باقات المكتب. الاسترداد العكسي قد يُنهي الصلاحية فوراً."
        },
        {
          title: "10. التوفر والتعديلات",
          content: "نسعى لتوفر عالٍ دون ضمان عدم الانقطاع. قد نعدّل أو نعلّق ميزات."
        },
        {
          title: "11. تحديد المسؤولية",
          content: "الخدمة «كما هي». لا مسؤولية عن أضرار غير مباشرة. سقف المسؤولية ما دُفع خلال 12 شهراً (أو صفر للمجاني/الترويجي). دليل المحامي والمكتبة مرجع عام ولا يُنشئ علاقة محامٍ–موكل مع أوبتيميز وير."
        },
        {
          title: "12. التعويض",
          content: "توافق على تعويض أوبتيميز وير عن مطالبات ناشئة عن استخدامك أو محتواك أو خرق الشروط أو القانون."
        },
        {
          title: "13. الإنهاء",
          content: "لأي طرف الإنهاء. قد نعلق أو ننهي عند المخالفة أو الإساءة. يتوقف الوصول فوراً."
        },
        {
          title: "14. برنامج الإحالة (2.3.0 — مفعّل)",
          content: "إحالة ناجحة: تسجيل المُحال بكودك وإكمال أول جلسة خلال 7 أيام. المكافأة: شهر Ad-Free واحد للمحيل فقط؛ المُحال لا يحصل على شهر مجاناً لمجرد الكود. الحد الأقصى 10 إحالات مكافأة لكل شهر تقويمي لكل محيل. لا تُحتسب الإحالة الذاتية أو الحسابات المكررة؛ قد نرفض أو نلغي المنح. يحق لمرافعة تعديل البرنامج أو إيقافه. ملخصات التطبيق للتوضيح وهذه الشروط تسود عند التعارض."
        },
        {
          title: "15. الاستبيانات والتحليلات والإعلانات",
          content: "الاستبيانات اختيارية. باستخدامك بعد التسجيل توافق على جمع الجلسات وإسناد الحملات كما في سياسة الخصوصية. قد تظهر إعلانات للحسابات غير المشمولة بـ Ad-Free."
        },
        {
          title: "16. القانون والنزاعات",
          content: "قوانين جمهورية مصر العربية ومحاكم القاهرة المختصة. يُفضَّل التفاوض بحسن نية أولاً."
        },
        {
          title: "17. القوة القاهرة وتعديل الشروط",
          content: "لسنا مسؤولين عن ظروف خارجة عن السيطرة المعقولة. قد نعدّل الشروط؛ التغييرات الجوهرية عبر إشعار عند الإمكان. استمرار الاستخدام قبول."
        },
        {
          title: "18. القابلية للفصل والاتفاقية الكاملة",
          content: "بطلان بند لا يبطل البقية. هذه الشروط مع سياسة الخصوصية هما الاتفاق الكامل."
        },
        {
          title: "19. التواصل وتاريخ السريان",
          content: "أوبتيميز وير — morafaaapp@gmail.com — +201202322241 — القاهرة، مصر. تسري الشروط اعتباراً من 23 أكتوبر 2026 (الإصدار 2.4.0)."
        }
      ]
    },
    en: {
      title: "Terms and Conditions",
      lastUpdated: "Last Updated: 23 October 2026 (Release 2.4.0)",
      sections: [
        {
          title: "1. Acceptance of Terms",
          content: "By using Morafaa you accept these Terms. If you do not agree, do not use the Service."
        },
        {
          title: "2. Definitions",
          content: "Platform: website, apps, and related services. User: anyone using the Platform. Content: uploaded or created materials. Service Provider: OptimizeWare. Client Data: client and case information. Ad-Free: an entitlement that suppresses in-app ads while active."
        },
        {
          title: "3. Service Description",
          content: "Legal practice tools for Egypt: clients, cases, calendar, files, collaboration, billing; Lawyer Guide and Legal Library (general reference, not legal advice); referral program with promotional Ad-Free rewards; optional surveys; analytics per Privacy Policy; ads on free tiers."
        },
        {
          title: "4. Eligibility and Registration",
          content: "Provide accurate information; protect credentials. Prefer one account per person/entity. Intended for adult legal professionals."
        },
        {
          title: "5. Acceptable Use",
          content: "Lawful use only. No illegal use, malware, unauthorized access, harassment, impersonation, harvesting data without consent, or referral abuse (including fake or self-referral schemes)."
        },
        {
          title: "6. Data Protection and Privacy",
          content: "Processing is described in the Privacy Policy (PDPL 151/2020), including TLS and processor controls and your access/correction/deletion rights."
        },
        {
          title: "7. Client Confidentiality",
          content: "Client Data remains your professional responsibility. We use it only to provide the Service and do not share it with ad networks for personalization. The Platform does not replace your ethical duties."
        },
        {
          title: "8. Intellectual Property",
          content: "Platform IP belongs to OptimizeWare. Your content remains yours with a limited license for us to host and process it."
        },
        {
          title: "9. Payment and Promotional Entitlements",
          content: "Paid prices are in EGP and VAT-inclusive unless we state otherwise. Kashier may process cards/wallets. Google Play Billing is not used for Ad-Free. Partial-period refunds are generally not provided unless Egyptian law requires. Referral Ad-Free months are not cash and may be revoked for abuse. We may disable in-app checkout or move it to the website without reducing a grant already paid."
        },
        {
          title: "9E. Paid Ad-Free (2.4.0 — live)",
          content: "Price: 50 EGP VAT-inclusive per grant. Duration: 30 days from verified payment — a one-time Kashier session, not a Google Play subscription and not silent auto-renew; a further period requires a new payment. Includes eligible ad suppression on app and web for that account. Excludes legal-library editions, AI tokens, and office plan tiers. Chargebacks may end access immediately."
        },
        {
          title: "10. Availability and Modifications",
          content: "We strive for high availability but do not guarantee uninterrupted service. Features may change or be suspended."
        },
        {
          title: "11. Limitation of Liability",
          content: "Service provided as is. No indirect damages. Liability capped at amounts paid in the prior 12 months (or zero for free/promotional use only). Lawyer Guide / Legal Library are general reference and do not create an attorney-client relationship with OptimizeWare."
        },
        {
          title: "12. Indemnification",
          content: "You indemnify OptimizeWare for claims arising from your use, content, or breach of these Terms or law."
        },
        {
          title: "13. Termination",
          content: "Either party may terminate. We may suspend or terminate for violations or abuse. Access ceases immediately."
        },
        {
          title: "14. Referral Program (2.3.0 — live)",
          content: "Successful referral: invitee registers with your code and completes a first session within 7 days. Reward: one Ad-Free month to the referrer only; invitee does not get Ad-Free solely for using a code. Cap: 10 rewarded referrals per calendar month per referrer. Self-referrals and duplicates do not qualify; we may refuse or revoke grants. Morafaa may modify or end the program. In-app summaries are convenience; these Terms control on conflict."
        },
        {
          title: "15. Surveys, Analytics, and Ads",
          content: "Surveys are optional. After registration you agree to session and one-time attribution collection per the Privacy Policy. Non–Ad-Free accounts may see ads."
        },
        {
          title: "16. Governing Law",
          content: "Laws of the Arab Republic of Egypt; competent courts of Cairo. Good-faith negotiation first."
        },
        {
          title: "17. Force Majeure and Modifications",
          content: "No liability for events beyond reasonable control. We may modify Terms; material changes notified where practicable. Continued use is acceptance."
        },
        {
          title: "18. Severability and Entire Agreement",
          content: "Invalid provisions are severed. These Terms plus the Privacy Policy are the entire agreement."
        },
        {
          title: "19. Contact and Effective Date",
          content: "OptimizeWare — morafaaapp@gmail.com — +201202322241 — Cairo, Egypt. Effective 23 October 2026 (Release 2.4.0)."
        }
      ]
    }
  };

  const currentContent = content[language as keyof typeof content];

  return (
    <div className={`min-h-screen bg-background-light dark:bg-background-dark ${isRTL ? 'rtl' : 'ltr'}`}>
      <AnnouncementBar />
      
      {/* Header */}
      <div className="bg-white dark:bg-gray-900 shadow-sm border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4 rtl:space-x-reverse">
              <button
                onClick={() => navigate(-1)}
                className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
              <div className="flex items-center space-x-3 rtl:space-x-reverse">
                <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                  <FileText className="w-6 h-6 text-accent" />
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                    {currentContent.title}
                  </h1>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {currentContent.lastUpdated}
                  </p>
                </div>
              </div>
            </div>
            
            {/* Theme & Language Toggle */}
            <div className="flex items-center space-x-3">
              <button
                onClick={toggleTheme}
                className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                title={language === 'ar' ? 'تبديل المظهر' : 'Toggle Theme'}
              >
                {isDark ? '☀️' : '🌙'}
              </button>
              
              <button
                onClick={() => setLanguage(language === 'ar' ? 'en' : 'ar')}
                className="px-3 py-1 text-sm rounded-md transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
              >
                {language === 'ar' ? 'English' : 'العربية'}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-8">
          {/* Introduction */}
          <div className="mb-8 p-6 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-200 dark:border-blue-800">
            <div className="flex items-start space-x-3 rtl:space-x-reverse">
              <Shield className="w-6 h-6 text-blue-600 dark:text-blue-400 mt-1 flex-shrink-0" />
              <div>
                <h2 className="text-lg font-semibold text-blue-900 dark:text-blue-100 mb-2">
                  {language === 'ar' ? 'مقدمة' : 'Introduction'}
                </h2>
                <p className="text-blue-800 dark:text-blue-200 leading-relaxed">
                  {language === 'ar' 
                    ? 'مرحباً بك في منصة مرافعة لإدارة الممارسة القانونية. هذه الشروط والأحكام تحكم استخدامك لمنصتنا وتحدد حقوقك ومسؤولياتك كعضو في مجتمعنا القانوني.'
                    : 'Welcome to the Morafaa legal practice management platform. These Terms and Conditions govern your use of our platform and define your rights and responsibilities as a member of our legal community.'
                  }
                </p>
              </div>
            </div>
          </div>

          {/* Terms Sections */}
          <div className="space-y-8">
            {currentContent.sections.map((section, index) => (
              <div key={index} className="border-b border-gray-200 dark:border-gray-700 pb-6 last:border-b-0">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4 flex items-center">
                  <span className="w-8 h-8 bg-primary rounded-full flex items-center justify-center text-white text-sm font-bold mr-3 rtl:mr-0 rtl:ml-3">
                    {index + 1}
                  </span>
                  {section.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-4 ml-11 rtl:ml-0 rtl:mr-11 leading-relaxed">
                  {section.content}
                </p>
              </div>
            ))}
          </div>

          {/* Important Notice */}
          <div className="mt-12 p-6 bg-amber-50 dark:bg-amber-900/20 rounded-xl border border-amber-200 dark:border-amber-800">
            <div className="flex items-start space-x-3 rtl:space-x-reverse">
              <AlertCircle className="w-6 h-6 text-amber-600 dark:text-amber-400 mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-lg font-semibold text-amber-900 dark:text-amber-100 mb-2">
                  {language === 'ar' ? 'إشعار مهم' : 'Important Notice'}
                </h3>
                <p className="text-amber-800 dark:text-amber-200 leading-relaxed">
                  {language === 'ar' 
                    ? 'يُنصح بقراءة هذه الشروط والأحكام بعناية. في حالة وجود أي أسئلة، يرجى التواصل معنا قبل استخدام المنصة. استمرار استخدامك للمنصة يعني موافقتك الكاملة على جميع البنود المذكورة أعلاه.'
                    : 'Please read these Terms and Conditions carefully. If you have any questions, please contact us before using the platform. Your continued use of the platform means your full agreement to all the terms mentioned above.'
                  }
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;
